<template>
  <div class="card-profile-employee p-0">
    <b-overlay :show="loading" rounded="sm">
      <template #overlay>
        <OverlayButton clase="overlay-md"> </OverlayButton>
      </template>
      <div>
        <div class="header">
          <p class="m-0">Datos del trabajador</p>
        </div>
        <b-row class="p-5">
          <!-- Imagen y pie de la misma -->
          <b-col class="box-avatar-information item-one">
            <b-row>
              <b-col cols="12" class="parent-avatar mt-4 mb-4">
                <b-avatar
                  class="avatar-imagen"
                  v-if="employee?.image"
                  :src="serverPath + '/' + employee?.image"
                />
                <b-avatar
                  v-else
                  :src="require('@/assets/images/login/avatar.svg')"
                  size="20rem"
                />
              </b-col>
              <b-col cols="12" class="child-avatar-information">
                <b-col class="cargo-avatar">
                  <img src="@/assets/images/icons/checkbox-circle-line.svg" />
                  <h4>Trabajador Activo</h4>
                </b-col>
                <b-col class="d-flex justify-content-center p-0">
                  <a href="">
                    Desde {{ employee?.created_at | moment(getHumanDate) }}
                  </a>
                </b-col>
              </b-col>
            </b-row>
          </b-col>
          <!-- end -->
          <!-- Formulario para mostar la informacion -->
          <b-col class="box-avatar-information item-two">
            <b-card-body>
              <b-card-text>
                <b-form>
                  <b-row>
                    <b-col cols="6" class="mb-5">
                      <Input
                        label="Nombre completo"
                        name="name"
                        :readonly="true"
                        :value="
                          employee?.employee
                            ? cutText(employee?.employee, 30)
                            : null
                        "
                      />
                    </b-col>

                    <b-col cols="6" class="mb-5">
                      <Input
                        label="Sexo"
                        name="gender"
                        :readonly="true"
                        :value="validIsNull(employee?.gender)"
                      />
                    </b-col>

                    <b-col cols="6" class="mb-5">
                      <Input
                        label="ID"
                        name="ID"
                        :readonly="true"
                        :value="employee?.cc"
                      />
                    </b-col>

                    <b-col cols="6" class="mb-5">
                      <Input
                        label="Edad"
                        name="age"
                        :readonly="true"
                        :value="validIsNull(employee?.age)"
                      />
                    </b-col>

                    <b-col cols="6" class="mb-5">
                      <Input
                        label="Área"
                        name="area"
                        :readonly="true"
                        :value="
                          employee?.area ? cutText(employee?.area, 17) : null
                        "
                      />
                    </b-col>

                    <b-col cols="6" class="mb-5">
                      <Input
                        label="Teléfono"
                        name="phone"
                        :readonly="true"
                        :value="validIsNull(employee?.phone)"
                      />
                    </b-col>

                    <b-col cols="6" class="mb-5">
                      <Input
                        label="Cargo"
                        name="charge"
                        :readonly="true"
                        :value="
                          employee?.charge
                            ? cutText(employee?.charge, 17)
                            : null
                        "
                      />
                    </b-col>

                    <b-col cols="6" class="mb-5">
                      <Input
                        label="Sindicato"
                        name="labor_union"
                        :readonly="true"
                        :value="employee?.labor_union"
                      />
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-text>
            </b-card-body>
          </b-col>
          <!-- end -->
        </b-row>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import serverConfig from "@/services/config";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import useInputs from "@/components/general/Inputs";

const { Input } = useInputs();

export default {
  components: {
    OverlayButton,
    Input,
  },
  props: {
    employee: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
    };
  },
  methods: {
    validIsNull(value) {
      return value ?? "N/A";
    },
  },
};
</script>

<style lang="scss">
.avatar-information-content {
  max-width: 780px;
  padding: 16px;
}
.avatar-information-content > .row {
  display: flex;
  flex-direction: column;
  gap: 36px;
  margin: 0;
  @media (min-width: 992px) {
    flex-direction: row;
  }
}
.box-avatar-information {
  width: 100%;
  padding: 0;
  @media (min-width: 992px) {
  }
  &.item-one {
    max-width: 300px;
    margin: 0 auto;
  }
}
.avatar-imagen {
  width: 10rem;
  height: 10rem;
  @media (min-width: 992px) {
    width: 168px;
    height: 168px;
  }
}
.cargo-avatar {
  background: #f6ffed;
  border-radius: 100px;
  display: flex;
  align-items: center;
  padding: 4px 6px;
  width: max-content;
  margin: 0 auto;
  gap: 8px;
}

.card {
  background: #ffffff;
  /* content/02 */
  border: 1px solid #cfd8dc;
  border-radius: 8px;
}

.parent-avatar {
  height: 70%;
  align-items: center;
  text-align: center;
  padding: 0;
  font: normal normal 400 16px/28px "Ubuntu";
  color: #263238;
}

.child-avatar-information {
  width: 82%;
  img {
    width: 20px;
    height: 20px;
    background: rgba(255, 255, 255, 0.001);

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
  }
  h4 {
    color: #00761a;
    margin: 0;
  }
  a {
    cursor: auto;
    color: black;
    font-weight: 400;
    font-size: 15px;
    line-height: 28px;
  }
}

.card-profile-employee {
  background-color: white;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #CFD8DC;
  // box-shadow: 0 0rem 0.5rem rgba(0, 0, 0, 0.175);
  .header {
    background-color: #eceff1;
    height: 48px;
    display: flex;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    align-items: center;
    padding-left: 20px;
    p {
      font-size: 16px;
      font-weight: 600;
      color: #263238;
    }
  }
}
</style>
